import { inject, Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

import { IonInput } from '@ionic/angular';
import { FormFocusService } from '@ts/shared/form/focus/util-core';
import { FocusService } from '@ts/shared/util-focus';

import { AutofocusIonicFieldInputProps } from './field.model';

interface SetAutofocusIfRequestedParams {
  props: AutofocusIonicFieldInputProps;
  ionInput: IonInput;
  formControl: FormControl;
}

@Injectable({
  providedIn: 'root',
})
export class FormFocusIonInputService {
  private focusService = inject(FocusService);
  private formFocusService = inject(FormFocusService);

  focus(ionInput: IonInput) {
    ionInput.getInputElement().then((element) => {
      this.focusService.focus({ element });
    });
  }

  setAutofocus(ionInput: IonInput, formControl: FormControl) {
    ionInput.getInputElement().then((element) => {
      this.formFocusService.setAutofocus(element, formControl);
    });
  }

  setAutofocusIfInProps({
    props,
    ionInput,
    formControl,
  }: SetAutofocusIfRequestedParams) {
    if (props.autofocus) {
      this.setAutofocus(ionInput, formControl);
    }
  }
}
